<template>
    <div v-if="isLoaded">
        <price-base-transport-outward-journey
            :prices.sync="outwardJourney"
            :priceOutbound.sync="priceOutbound"
            :seasons.sync="seasons"
            :service.sync="service"
        ></price-base-transport-outward-journey>
        <price-base-transport-return-trip
            v-if="priceOutbound"
            :prices.sync="returnTrip"
            :service.sync="service"
        ></price-base-transport-return-trip>
    </div>
</template>

<script>
import Price from '@/services/hatsApi/Price'

export default {
  data () {
    return {
      outwardJourney: [],
      returnTrip: [],
      priceOutbound: parseInt(this.service.priceOutbound),
      seasons: parseInt(this.service.seasons),
      isLoaded: false
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    basePrices: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  async created () {
    if (!this.outwardJourney.length) {
      try {
        let outboundFlag = parseInt(this.service.priceOutbound) ? 2 : 3
        let filter = [
          {
            property: 'serviceId',
            value: this.$route.params.type_id
          },
          {
            property: 'outbound',
            value: outboundFlag
          }
        ]
        const basePriceResponse = await Price.getBasePrices(filter)
        this.outwardJourney = basePriceResponse.data.data
      } catch (error) {
        console.log(error)
      }
    }
    if (!this.returnTrip.length && this.service.priceOutbound === '1') {
      try {
        let filter = [
          {
            property: 'serviceId',
            value: this.$route.params.type_id
          },
          {
            property: 'outbound',
            value: 1
          }
        ]
        const basePriceResponse = await Price.getBasePrices(filter)
        this.returnTrip = basePriceResponse.data.data
      } catch (error) {
        console.log(error)
      }
    }
    this.isLoaded = true
  },
  methods: {
    combineTrip () {
      let trips = []
      this.outwardJourney.forEach((trip) => {
        trips.push(trip)
      })
      this.returnTrip.forEach((trip) => {
        trips.push(trip)
      })
      this.$emit('update:basePrices', trips)
    }
  },
  watch: {
    outwardJourney: {
      handler: 'combineTrip',
      deep: true
    },
    returnTrip: {
      handler: 'combineTrip',
      deep: true
    },
    priceOutbound (val) {
      this.service.priceOutbound = val
      if (!val) {
        this.returnTrip = []
        this.combineTrip()
      }
    },
    seasons (val) {
      this.service.seasons = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/base/TransferType.vue